function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var AvailableUnitsTemplate = require('./available-units.template');
var AvailableUnitsOverlay = /*#__PURE__*/function () {
  function AvailableUnitsOverlay(app, mod, c1, c2, c3) {
    _classCallCheck(this, AvailableUnitsOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.max_units = 0;
    this.ops_spend = 0;
    this.units_already_moved_by_idx = [];
    this.is_unit_already_moved_by_idx_a_leader = [];
    this.added = 0; // just idx tracker
    this.faded_out = false;
  }
  return _createClass(AvailableUnitsOverlay, [{
    key: "hide",
    value: function hide() {
      var obj = document.querySelector('.available-units-overlay');
      if (obj) {
        obj.remove();
      }
      this.faded_out = false;
    }
  }, {
    key: "fadeOut",
    value: function fadeOut() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      try {
        if (this.units_already_moved_by_idx.length == 0 || force == true) {
          this.faded_out = true;
          document.querySelector('.movement-overlay .available-units-overlay').style.backgroundColor = '#0009';
          document.querySelector('.movement-overlay .available-units-overlay').style.opacity = 0.2;
        }
      } catch (err) {}
      document.querySelectorAll('.available-units-overlay .army_tile').forEach(function (el) {
        el.onclick = function (e) {};
      });
    }
  }, {
    key: "renderMove",
    value: function renderMove(mobj, faction, spacekey) {
      var _this = this;
      var max_formation_size = this.mod.returnMaxFormationSize(mobj.units_to_move, faction, spacekey);

      //
      // this manually moves multiple units, skirting the restrictions on moving
      // single units that is imposed on the lowest-level (his-player) and which
      // bites if we are already over-capacity on unit construction...
      //
      if (mobj.units_to_move.length == 0) {
        document.querySelectorAll('.available-units-overlay .army_tile').forEach(function (el) {
          if (el.classList.contains('nonopaque')) {
            el.classList.remove('nonopaque');
            el.classList.add('opaque');
          }
        });
      }
      var his_self = this.mod;
      var qs = '.movement-overlay .available-units-overlay';
      if (!document.querySelector('.available-units-overlay')) {
        his_self.app.browser.addElementToDom(AvailableUnitsTemplate());
      } else {
        document.querySelector('.available-units-overlay').innerHTML = "";
      }
      var p = this.mod.returnPlayerCommandingFaction(faction);
      var io = this.mod.game.spaces[spacekey].units;
      this.added = 0;
      if (this.faded_out) {
        this.fadeOut(true);
      }
      for (var f in io) {
        if (this.mod.isAlliedMinorPower(f, faction) || f === faction) {
          var x = this.mod.returnOnBoardUnits(f);
          if (x.deployed[spacekey]) {
            var us = x.deployed[spacekey];
            var usm = x.missing[spacekey];
            var army_leaders = [];
            //
            // HACK -- fetch army leaders from separate mobj data structure
            //
            for (var i = 0; i < io[f].length; i++) {
              var u = io[f][i];
              if (u.army_leader) {
                document.querySelector(qs).innerHTML += this.returnTile(f, i, u.type, i, true); // true = leader
              }
            }
            if (us['regular']) {
              for (var _i = 0; _i < us['regular']['1']; _i++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'regular', 1);
              }
              for (var _i2 = 0; _i2 < us['regular']['2']; _i2++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'regular', 2);
              }
              for (var _i3 = 0; _i3 < us['regular']['3']; _i3++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'regular', 3);
              }
              for (var _i4 = 0; _i4 < us['regular']['4']; _i4++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'regular', 4);
              }
              for (var _i5 = 0; _i5 < us['regular']['5']; _i5++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'regular', 5);
              }
              for (var _i6 = 0; _i6 < us['regular']['6']; _i6++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'regular', 6);
              }
              for (var _i7 = 0; _i7 < usm['regular']['1']; _i7++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'regular', 1);
              }
            }
            if (us['cavalry']) {
              for (var _i8 = 0; _i8 < us['cavalry']['1']; _i8++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'cavalry', 1);
              }
              for (var _i9 = 0; _i9 < us['cavalry']['2']; _i9++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'cavalry', 2);
              }
              for (var _i0 = 0; _i0 < us['cavalry']['3']; _i0++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'cavalry', 3);
              }
              for (var _i1 = 0; _i1 < us['cavalry']['4']; _i1++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'cavalry', 4);
              }
              for (var _i10 = 0; _i10 < us['cavalry']['5']; _i10++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'cavalry', 5);
              }
              for (var _i11 = 0; _i11 < us['cavalry']['6']; _i11++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'cavalry', 6);
              }
              for (var _i12 = 0; _i12 < usm['cavalry']['1']; _i12++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'cavalry', 1);
              }
            }
            if (us['mercenary']) {
              for (var _i13 = 0; _i13 < us['mercenary']['1']; _i13++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'mercenary', 1);
              }
              for (var _i14 = 0; _i14 < us['mercenary']['2']; _i14++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'mercenary', 2);
              }
              for (var _i15 = 0; _i15 < us['mercenary']['3']; _i15++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'mercenary', 3);
              }
              for (var _i16 = 0; _i16 < us['mercenary']['4']; _i16++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'mercenary', 4);
              }
              for (var _i17 = 0; _i17 < us['mercenary']['5']; _i17++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'mercenary', 5);
              }
              for (var _i18 = 0; _i18 < us['mercenary']['6']; _i18++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'mercenary', 6);
              }
              for (var _i19 = 0; _i19 < usm['mercenary']['1']; _i19++) {
                document.querySelector(qs).innerHTML += this.returnTile(f, this.added, 'mercenary', 1);
              }
            }
          } // if exists
        }
      }

      //
      // this manually moves multiple units, skirting the restrictions on moving
      // single units that is imposed on the lowest-level (his-player) and which
      // bites if we are already over-capacity on unit construction...
      //
      document.querySelectorAll('.available-units-overlay .army_tile').forEach(function (el) {
        el.onclick = function (e) {
          var adding = false;
          if (e.currentTarget.classList.contains('nonopaque')) {
            e.currentTarget.classList.remove('nonopaque');
            e.currentTarget.classList.add('opaque');
          } else {
            e.currentTarget.classList.remove('opaque');
            e.currentTarget.classList.add('nonopaque');
            adding = true;
          }
          var id = e.currentTarget.id;
          var x = id.split('-');
          var num = parseInt(x[0]);
          var faction = x[1];
          var type = x[2];
          var is_army_leader = false;
          var original_type = type;
          if (type.indexOf('_') > 0) {
            is_army_leader = true;
            type = type.replace(/_/g, '-');
          }
          if (type === 'renegade' || type === 'dudley' || type === 'montmorency' || type === 'ferdinand' || type === 'suleiman') {
            is_army_leader = true;
          }
          var idx = parseInt(x[3]);
          var mobj = _this.mod.movement_overlay.mobj;
          var existing_land_units = 0;
          for (var z = 0; z < mobj.moved_units.length; z++) {
            if (mobj.moved_units[z].type == 'regular' || mobj.moved_units[z].type == 'mercenary' || mobj.moved_units[z].type == 'cavalry') {
              existing_land_units++;
            }
          }
          if (max_formation_size < num + existing_land_units && adding == true) {
            alert('You cannot move these units without surpassing your max formation capacity of ' + max_formation_size);
            if (e.currentTarget.classList.contains('nonopaque')) {
              e.currentTarget.classList.remove('nonopaque');
              e.currentTarget.classList.add('opaque');
            } else {
              e.currentTarget.classList.remove('opaque');
              e.currentTarget.classList.add('nonopaque');
            }
            return;
          }
          if (adding == true) {
            _this.units_already_moved_by_idx.push(idx);
            if (is_army_leader) {
              _this.is_unit_already_moved_by_idx_a_leader.push(1);
            } else {
              _this.is_unit_already_moved_by_idx_a_leader.push(0);
            }
            var _qs = ".regular:nth-child(-n+" + num + ")";
            var objs = document.querySelectorAll(_qs);
            for (var _i20 = 0; _i20 < num; _i20++) {
              var moved = false;
              for (var _z = 0; _z < mobj.unmoved_units.length; _z++) {
                if (mobj.unmoved_units[_z].faction == faction && mobj.unmoved_units[_z].type == type && moved == false) {
                  mobj.moved_units.push(mobj.unmoved_units[_z]);
                  mobj.units_to_move.push(JSON.parse(JSON.stringify(mobj.unmoved_units[_z])));
                  mobj.unmoved_units.splice(_z, 1);
                  _z--;
                  moved = true;
                }
              }
            }
          } else {
            for (var _z2 = 0; _z2 < _this.units_already_moved_by_idx.length; _z2++) {
              if (is_army_leader) {
                if (_this.is_unit_already_moved_by_idx_a_leader[_z2] == 1 && _this.units_already_moved_by_idx[_z2] === idx) {
                  _this.units_already_moved_by_idx.splice(_z2, 1);
                  _this.is_unit_already_moved_by_idx_a_leader.splice(_z2, 1);
                  //
                  // because we are removing an army leader, we remove everything
                  //
                  _this.units_already_moved_by_idx = [];
                  _this.is_unit_already_moved_by_idx_a_leader = [];
                  _z2 = 10000;
                  for (var ii = mobj.moved_units.length - 1; ii >= 0; ii--) {
                    mobj.unmoved_units.push(mobj.moved_units[ii]);
                  }
                  mobj.moved_units = [];
                  mobj.units_to_move = [];
                  _this.mod.movement_overlay.selectUnitsInterface(_this.mod, mobj.units_to_move, _this.mod.movement_overlay.selectUnitsInterface, _this.mod.movement_overlay.selectDestinationInterface);
                  return;
                }
              } else {
                if (_this.is_unit_already_moved_by_idx_a_leader[_z2] == 0 && _this.units_already_moved_by_idx[_z2] === idx) {
                  _this.units_already_moved_by_idx.splice(_z2, 1);
                  _this.is_unit_already_moved_by_idx_a_leader.splice(_z2, 1);
                  _z2--;
                }
              }
            }
            for (var _i21 = 0; _i21 < num; _i21++) {
              var _moved = false;
              for (var _z3 = 0; _z3 < mobj.moved_units.length && _moved == false; _z3++) {
                if (mobj.moved_units[_z3].faction == faction && mobj.moved_units[_z3].type == type && _moved == false) {
                  var mrem = false;
                  for (var yy = 0; yy < mobj.units_to_move.length; yy++) {
                    if (mobj.units_to_move[yy].faction == faction && mobj.units_to_move[yy].type == type && mrem == false) {
                      mobj.units_to_move.splice(yy, 1);
                      mrem = true;
                      yy--;
                      break;
                    }
                  }
                  mobj.unmoved_units.push(mobj.moved_units[_z3]);
                  mobj.moved_units.splice(_z3, 1);
                  _z3--;
                  _moved = true;
                }
              }
            }
          }
          _this.mod.movement_overlay.selectUnitsInterface(_this.mod, mobj.units_to_move, _this.mod.movement_overlay.selectUnitsInterface, _this.mod.movement_overlay.selectDestinationInterface);
        };
      });
    }
  }, {
    key: "renderBuild",
    value: function renderBuild(faction, unit, ops, cost, mycallback) {
      var his_self = this.mod;
      if (!document.querySelector('.available-units-overlay')) {
        his_self.app.browser.addElementToDom(AvailableUnitsTemplate());
      } else {
        document.querySelector('.available-units-overlay').innerHTML = "";
      }
      this.max_units = his_self.returnNumberOfUnitsAvailableForConstruction(faction, unit);
      this.addUnitsAvailableToPage(faction, unit, ops / cost);
      document.querySelectorAll('.available-units-overlay .army_tile').forEach(function (el) {
        el.onclick = function (e) {
          var num = parseInt(e.currentTarget.id);
          if (cost * num > ops) {
            alert('You do not have the OPs to purchase that many units');
            return;
          }
          mycallback(num);
        };
      });
    }
  }, {
    key: "returnTile",
    value: function returnTile(faction) {
      var added = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var utype = arguments.length > 2 ? arguments[2] : undefined;
      var num = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var leader = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var muc = 'opaque';
      if (leader == false) {
        if (this.units_already_moved_by_idx.includes(added)) {
          for (var z = 0; z < this.units_already_moved_by_idx.length; z++) {
            if (this.is_unit_already_moved_by_idx_a_leader[z] == 0 && this.units_already_moved_by_idx[z] === added) {
              muc = 'nonopaque';
            }
          }
        }
      } else {
        if (this.units_already_moved_by_idx.includes(added)) {
          for (var _z4 = 0; _z4 < this.units_already_moved_by_idx.length; _z4++) {
            if (this.is_unit_already_moved_by_idx_a_leader[_z4] == 1 && this.units_already_moved_by_idx[_z4] === added) {
              muc = 'nonopaque';
            }
          }
        }
      }
      var imgtile = '';
      if (leader) {
        imgtile = "<img class=\"army_tile ".concat(muc, "\" id=\"1-").concat(faction, "-").concat(utype.replace(/-/g, '_'), "-").concat(num, "\" src=\"/his/img/tiles/army/").concat(this.mod.army[utype].img, "\" />");
        return imgtile;
      }
      if (utype == 'regular') {
        if (faction == 'hapsburg') {
          imgtile = "<img id=\"".concat(num, "-hapsburg-regular-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/hapsburg/HapsburgReg-").concat(num, ".svg\" />");
        }
        if (faction == 'papacy') {
          imgtile = "<img id=\"".concat(num, "-papacy-regular-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/papacy/PapacyReg-").concat(num, ".svg\" />");
        }
        if (faction == 'protestant') {
          imgtile = "<img id=\"".concat(num, "-protestant-regular-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/protestant/ProtestantReg-").concat(num, ".svg\" />");
        }
        if (faction == 'ottoman') {
          imgtile = "<img id=\"".concat(num, "-ottoman-regular-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanReg-").concat(num, ".svg\" />");
        }
        if (faction == 'france') {
          imgtile = "<img id=\"".concat(num, "-france-regular-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/france/FrenchReg-").concat(num, ".svg\" />");
        }
        if (faction == 'england') {
          imgtile = "<img id=\"".concat(num, "-england-regular-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/england/EnglandReg-").concat(num, ".svg\" />");
        }
        if (faction == 'independent') {
          imgtile = "<img id=\"".concat(num, "-independent-regular-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/independent/IndependentReg-").concat(num, ".svg\" />");
        }
        if (faction == 'scotland') {
          imgtile = "<img id=\"".concat(num, "-scotland-regular-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/scotland/ScottishReg-").concat(num, ".svg\" />");
        }
        if (faction == 'venice') {
          imgtile = "<img id=\"".concat(num, "-venice-regular-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/venice/VeniceReg-").concat(num, ".svg\" />");
        }
        if (faction == 'hungary') {
          imgtile = "<img id=\"".concat(num, "-hungary-regular-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/hungary/HungaryReg-").concat(num, ".svg\" />");
        }
        if (faction == 'genoa') {
          imgtile = "<img id=\"".concat(num, "-genoa-regular-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/genoa/GenoaReg-").concat(num, ".svg\" />");
        }
      }
      if (utype == 'mercenary') {
        if (faction == 'hapsburg') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-mercenary-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/hapsburg/HapsburgMerc-").concat(num, ".svg\" />");
        }
        if (faction == 'papacy') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-mercenary-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/papacy/PapacyMerc-").concat(num, ".svg\" />");
        }
        if (faction == 'protestant') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-mercenary-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/protestant/ProtestantMerc-").concat(num, ".svg\" />");
        }
        if (faction == 'ottoman') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-mercenary-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanMerc-").concat(num, ".svg\" />");
        }
        if (faction == 'france') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-mercenary-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/france/FrenchMerc-").concat(num, ".svg\" />");
        }
        if (faction == 'england') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-mercenary-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/england/EnglandMerc-").concat(num, ".svg\" />");
        }
        if (faction == 'independent') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-mercenary-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/independent/IndependentMerc-").concat(num, ".svg\" />");
        }
        if (faction == 'scotland') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-mercenary-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/scotland/ScottishMerc-").concat(num, ".svg\" />");
        }
        if (faction == 'venice') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-mercenary-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/venice/VeniceMerc-").concat(num, ".svg\" />");
        }
        if (faction == 'hungary') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-mercenary-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/hungary/HungaryMerc-").concat(num, ".svg\" />");
        }
        if (faction == 'genoa') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-mercenary-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/genoa/GenoaMerc-").concat(num, ".svg\" />");
        }
      }
      if (utype == 'cavalry') {
        if (faction == 'hapsburg') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-cavalry-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/hapsburg/HapsburgCav-").concat(num, ".svg\" />");
        }
        if (faction == 'papacy') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-cavalry-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/papacy/PapacyCav-").concat(num, ".svg\" />");
        }
        if (faction == 'protestant') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-cavalry-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/protestant/ProtestantCav-").concat(num, ".svg\" />");
        }
        if (faction == 'ottoman') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-cavalry-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanCav-").concat(num, ".svg\" />");
        }
        if (faction == 'france') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-cavalry-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/france/FrenchCav-").concat(num, ".svg\" />");
        }
        if (faction == 'england') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-cavalry-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/england/EnglandCav-").concat(num, ".svg\" />");
        }
        if (faction == 'independent') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-cavalry-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/independent/IndependentCav-").concat(num, ".svg\" />");
        }
        if (faction == 'scotland') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-cavalry-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/scotland/ScottishCav-").concat(num, ".svg\" />");
        }
        if (faction == 'venice') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-cavalry-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/venice/VeniceCav-").concat(num, ".svg\" />");
        }
        if (faction == 'hungary') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-cavalry-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/hungary/HungaryCav-").concat(num, ".svg\" />");
        }
        if (faction == 'genoa') {
          imgtile = "<img id=\"".concat(num, "-").concat(faction, "-cavalry-").concat(added, "\" class=\"army_tile ").concat(muc, "\" src=\"/his/img/tiles/genoa/GenoaCav-").concat(num, ".svg\" />");
        }
      }
      this.added++; // prepare for next loop

      return imgtile;
    }
  }, {
    key: "addUnitsAvailableToPage",
    value: function addUnitsAvailableToPage() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var utype = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'regular';
      var max_units = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
      var his_self = this.mod;
      var f = faction;
      var muc = '';
      var available = his_self.game.state.board[f].available;
      if (utype == 'regular') {
        for (var i = 0; i < available['regular']['1']; i++) {
          if (max_units < 1) {
            muc = ' unavailable';
          }
          var imgtile = '';
          if (f == 'hapsburg') {
            imgtile = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hapsburg/HapsburgReg-1.svg\" />");
          }
          if (f == 'protestant') {
            imgtile = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/protestant/ProtestantReg-1.svg\" />");
          }
          if (f == 'papacy') {
            imgtile = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/papacy/PapacyReg-1.svg\" />");
          }
          if (f == 'ottoman') {
            imgtile = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanReg-1.svg\" />");
          }
          if (f == 'france') {
            imgtile = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/france/FrenchReg-1.svg\" />");
          }
          if (f == 'england') {
            imgtile = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/england/EnglandReg-1.svg\" />");
          }
          if (f == 'scotland') {
            imgtile = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/scotland/ScottishReg-1.svg\" />");
          }
          if (f == 'venice') {
            imgtile = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/venice/VeniceReg-1.svg\" />");
          }
          if (f == 'genoa') {
            imgtile = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/genoa/GenoaReg-1.svg\" />");
          }
          if (f == 'hungary') {
            imgtile = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hungary/HungaryReg-1.svg\" />");
          }
          if (f == 'independent') {
            imgtile = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/independent/IndependentReg-1.svg\" />");
          }
          var qs = ".available-units-overlay";
          his_self.app.browser.addElementToSelector(imgtile, qs);
        }
        for (var _i22 = 0; _i22 < available['regular']['2']; _i22++) {
          if (max_units < 2) {
            muc = ' unavailable';
          }
          var _imgtile = '';
          if (f == 'hapsburg') {
            _imgtile = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hapsburg/HapsburgReg-2.svg\" />");
          }
          if (f == 'protestant') {
            _imgtile = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/protestant/ProtestantReg-2.svg\" />");
          }
          if (f == 'papacy') {
            _imgtile = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/papacy/PapacyReg-2.svg\" />");
          }
          if (f == 'ottoman') {
            _imgtile = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanReg-2.svg\" />");
          }
          if (f == 'france') {
            _imgtile = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/france/FrenchReg-2.svg\" />");
          }
          if (f == 'england') {
            _imgtile = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/england/EnglandReg-2.svg\" />");
          }
          if (f == 'scotland') {
            _imgtile = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/scotland/ScottishReg-2.svg\" />");
          }
          if (f == 'venice') {
            _imgtile = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/venice/VeniceReg-2.svg\" />");
          }
          if (f == 'genoa') {
            _imgtile = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/genoa/GenoaReg-2.svg\" />");
          }
          if (f == 'hungary') {
            _imgtile = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hungary/HungaryReg-2.svg\" />");
          }
          if (f == 'independent') {
            _imgtile = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/independent/IndependentReg-2.svg\" />");
          }
          var _qs2 = ".available-units-overlay";
          his_self.app.browser.addElementToSelector(_imgtile, _qs2);
        }
        for (var _i23 = 0; _i23 < available['regular']['4']; _i23++) {
          if (max_units < 4) {
            muc = ' unavailable';
          }
          var _imgtile2 = '';
          if (f == 'hapsburg') {
            _imgtile2 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hapsburg/HapsburgReg-4.svg\" />");
          }
          if (f == 'protestant') {
            _imgtile2 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/protestant/ProtestantReg-4.svg\" />");
          }
          if (f == 'papacy') {
            _imgtile2 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/papacy/PapacyReg-4.svg\" />");
          }
          if (f == 'ottoman') {
            _imgtile2 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanReg-4.svg\" />");
          }
          if (f == 'france') {
            _imgtile2 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/france/FrenchReg-4.svg\" />");
          }
          if (f == 'england') {
            _imgtile2 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/england/EnglandReg-4.svg\" />");
          }
          if (f == 'scotland') {
            _imgtile2 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/scotland/ScottishReg-4.svg\" />");
          }
          if (f == 'venice') {
            _imgtile2 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/venice/VeniceReg-4.svg\" />");
          }
          if (f == 'genoa') {
            _imgtile2 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/genoa/GenoaReg-4.svg\" />");
          }
          if (f == 'hungary') {
            _imgtile2 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hungary/HungaryReg-4.svg\" />");
          }
          if (f == 'independent') {
            _imgtile2 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/independent/IndependentReg-4.svg\" />");
          }
          var _qs3 = ".available-units-overlay";
          his_self.app.browser.addElementToSelector(_imgtile2, _qs3);
        }
        for (var _i24 = 0; _i24 < available['regular']['6']; _i24++) {
          if (max_units < 6) {
            muc = ' unavailable';
          }
          var _imgtile3 = '';
          if (f == 'hapsburg') {
            _imgtile3 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hapsburg/HapsburgReg-6.svg\" />");
          }
          if (f == 'protestant') {
            _imgtile3 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/protestant/ProtestantReg-6.svg\" />");
          }
          if (f == 'papacy') {
            _imgtile3 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/papacy/PapacyReg-6.svg\" />");
          }
          if (f == 'ottoman') {
            _imgtile3 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanReg-6.svg\" />");
          }
          if (f == 'france') {
            _imgtile3 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/france/FrenchReg-6.svg\" />");
          }
          if (f == 'england') {
            _imgtile3 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/england/EnglandReg-6.svg\" />");
          }
          if (f == 'scotland') {
            _imgtile3 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/scotland/ScottishReg-6.svg\" />");
          }
          if (f == 'venice') {
            _imgtile3 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/venice/VeniceReg-6.svg\" />");
          }
          if (f == 'genoa') {
            _imgtile3 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/genoa/GenoaReg-6.svg\" />");
          }
          if (f == 'hungary') {
            _imgtile3 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hungary/HungaryReg-6.svg\" />");
          }
          if (f == 'independent') {
            _imgtile3 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/independent/IndependentReg-6.svg\" />");
          }
          var _qs4 = ".available-units-overlay";
          his_self.app.browser.addElementToSelector(_imgtile3, _qs4);
        }
      }
      if (utype == 'mercenary') {
        for (var _i25 = 0; _i25 < available['regular']['1']; _i25++) {
          if (max_units < 1) {
            muc = ' unavailable';
          }
          var _imgtile4 = '';
          if (f == 'hapsburg') {
            _imgtile4 = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hapsburg/HapsburgMerc-1.svg\" />");
          }
          if (f == 'protestant') {
            _imgtile4 = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/protestant/ProtestantMerc-1.svg\" />");
          }
          if (f == 'papacy') {
            _imgtile4 = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/papacy/PapacyMerc-1.svg\" />");
          }
          if (f == 'ottoman') {
            _imgtile4 = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanMerc-1.svg\" />");
          }
          if (f == 'france') {
            _imgtile4 = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/france/FrenchMerc-1.svg\" />");
          }
          if (f == 'england') {
            _imgtile4 = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/england/EnglandMerc-1.svg\" />");
          }
          if (f == 'scotland') {
            _imgtile4 = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/scotland/ScottishMerc-1.svg\" />");
          }
          if (f == 'venice') {
            _imgtile4 = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/venice/VeniceMerc-1.svg\" />");
          }
          if (f == 'genoa') {
            _imgtile4 = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/genoa/GenoaMerc-1.svg\" />");
          }
          if (f == 'hungary') {
            _imgtile4 = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hungary/HungaryMerc-1.svg\" />");
          }
          if (f == 'independent') {
            _imgtile4 = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/independent/IndependentMerc-1.svg\" />");
          }
          var _qs5 = ".available-units-overlay";
          his_self.app.browser.addElementToSelector(_imgtile4, _qs5);
        }
        for (var _i26 = 0; _i26 < available['regular']['2']; _i26++) {
          if (max_units < 2) {
            muc = ' unavailable';
          }
          var _imgtile5 = '';
          if (f == 'hapsburg') {
            _imgtile5 = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hapsburg/HapsburgMerc-2.svg\" />");
          }
          if (f == 'protestant') {
            _imgtile5 = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/protestant/ProtestantMerc-2.svg\" />");
          }
          if (f == 'papacy') {
            _imgtile5 = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/papacy/PapacyMerc-2.svg\" />");
          }
          if (f == 'ottoman') {
            _imgtile5 = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanMerc-2.svg\" />");
          }
          if (f == 'france') {
            _imgtile5 = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/france/FrenchMerc-2.svg\" />");
          }
          if (f == 'england') {
            _imgtile5 = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/england/EnglandMerc-2.svg\" />");
          }
          if (f == 'scotland') {
            _imgtile5 = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/scotland/ScottishMerc-2.svg\" />");
          }
          if (f == 'venice') {
            _imgtile5 = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/venice/VeniceMerc-2.svg\" />");
          }
          if (f == 'genoa') {
            _imgtile5 = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/genoa/GenoaMerc-2.svg\" />");
          }
          if (f == 'hungary') {
            _imgtile5 = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hungary/HungaryMerc-2.svg\" />");
          }
          if (f == 'independent') {
            _imgtile5 = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/independent/IndependentMerc-2.svg\" />");
          }
          var _qs6 = ".available-units-overlay";
          his_self.app.browser.addElementToSelector(_imgtile5, _qs6);
        }
        for (var _i27 = 0; _i27 < available['regular']['4']; _i27++) {
          if (max_units < 4) {
            muc = ' unavailable';
          }
          var _imgtile6 = '';
          if (f == 'hapsburg') {
            _imgtile6 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hapsburg/HapsburgMerc-4.svg\" />");
          }
          if (f == 'protestant') {
            _imgtile6 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/protestant/ProtestantMerc-4.svg\" />");
          }
          if (f == 'papacy') {
            _imgtile6 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/papacy/PapacyMerc-4.svg\" />");
          }
          if (f == 'ottoman') {
            _imgtile6 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanMerc-4.svg\" />");
          }
          if (f == 'france') {
            _imgtile6 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/france/FrenchMerc-4.svg\" />");
          }
          if (f == 'england') {
            _imgtile6 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/england/EnglandMerc-4.svg\" />");
          }
          if (f == 'scotland') {
            _imgtile6 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/scotland/ScottishMerc-4.svg\" />");
          }
          if (f == 'venice') {
            _imgtile6 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/venice/VeniceMerc-4.svg\" />");
          }
          if (f == 'genoa') {
            _imgtile6 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/genoa/GenoaMerc-4.svg\" />");
          }
          if (f == 'hungary') {
            _imgtile6 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hungary/HungaryMerc-4.svg\" />");
          }
          if (f == 'independent') {
            _imgtile6 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/independent/IndependentMerc-4.svg\" />");
          }
          var _qs7 = ".available-units-overlay";
          his_self.app.browser.addElementToSelector(_imgtile6, _qs7);
        }
        for (var _i28 = 0; _i28 < available['regular']['6']; _i28++) {
          if (max_units < 6) {
            muc = ' unavailable';
          }
          var _imgtile7 = '';
          if (f == 'hapsburg') {
            _imgtile7 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hapsburg/HapsburgMerc-6.svg\" />");
          }
          if (f == 'protestant') {
            _imgtile7 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/protestant/ProtestantMerc-6.svg\" />");
          }
          if (f == 'papacy') {
            _imgtile7 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/papacy/PapacyMerc-6.svg\" />");
          }
          if (f == 'ottoman') {
            _imgtile7 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanMerc-6.svg\" />");
          }
          if (f == 'france') {
            _imgtile7 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/france/FrenchMerc-6.svg\" />");
          }
          if (f == 'england') {
            _imgtile7 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/england/EnglandMerc-6.svg\" />");
          }
          if (f == 'scotland') {
            _imgtile7 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/scotland/ScottishMerc-6.svg\" />");
          }
          if (f == 'venice') {
            _imgtile7 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/venice/VeniceMerc-6.svg\" />");
          }
          if (f == 'genoa') {
            _imgtile7 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/genoa/GenoaMerc-6.svg\" />");
          }
          if (f == 'hungary') {
            _imgtile7 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/hungary/HungaryMerc-6.svg\" />");
          }
          if (f == 'independent') {
            _imgtile7 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/independent/IndependentMerc-6.svg\" />");
          }
          var _qs8 = ".available-units-overlay";
          his_self.app.browser.addElementToSelector(_imgtile7, _qs8);
        }
      }
      if (utype == 'cavalry') {
        for (var _i29 = 0; _i29 < available['regular']['1']; _i29++) {
          if (max_units < 1) {
            muc = ' unavailable';
          }
          var _imgtile8 = '';
          if (f == 'ottoman') {
            _imgtile8 = "<img id=\"1\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanCav-1.svg\" />");
          }
          var _qs9 = ".available-units-overlay";
          his_self.app.browser.addElementToSelector(_imgtile8, _qs9);
        }
        for (var _i30 = 0; _i30 < available['regular']['2']; _i30++) {
          if (max_units < 2) {
            muc = ' unavailable';
          }
          var _imgtile9 = '';
          if (f == 'ottoman') {
            _imgtile9 = "<img id=\"2\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanCav-2.svg\" />");
          }
          var _qs0 = ".available-units-overlay";
          his_self.app.browser.addElementToSelector(_imgtile9, _qs0);
        }
        for (var _i31 = 0; _i31 < available['regular']['4']; _i31++) {
          if (max_units < 4) {
            muc = ' unavailable';
          }
          var _imgtile0 = '';
          if (f == 'ottoman') {
            _imgtile0 = "<img id=\"4\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanCav-4.svg\" />");
          }
          var _qs1 = ".available-units-overlay";
          his_self.app.browser.addElementToSelector(_imgtile0, _qs1);
        }
        for (var _i32 = 0; _i32 < available['regular']['6']; _i32++) {
          if (max_units < 6) {
            muc = ' unavailable';
          }
          var _imgtile1 = '';
          if (f == 'ottoman') {
            _imgtile1 = "<img id=\"6\" class=\"army_tile ".concat(muc, "\" src=\"/his/img/tiles/ottoman/OttomanCav-6.svg\" />");
          }
          var _qs10 = ".available-units-overlay";
          his_self.app.browser.addElementToSelector(_imgtile1, _qs10);
        }
      }
    }
  }]);
}();
module.exports = AvailableUnitsOverlay;